@import '@hevoio/hevo-ui-toolkit/styles/variables';

.banner {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: $spacer * .75 $spacer * 1.25;
  color: $light-text;
}

.banner.inline {
  padding-left: $spacer;
  padding-right: $spacer;
}

.bannerContent {
  margin-right: $spacer;
  display: inline;
}

.bannerTitle {
  font-weight: $font-weight-bold;
  display: inline;
  &:not(:empty) {
    margin-right: $spacer * 0.25;
  }
}

.bannerThumbnail {
  display: inline-flex;
  font-size: $icon-size-base * 1.25;
  margin-top: -2px;
  margin-bottom: -2px;
  flex-shrink: 0;
}

img.bannerThumbnail {
  display: inline-flex;
  flex-shrink: 0;
  height: 28px;
  margin-top: -6px;
  margin-bottom: -6px;
}

.closeBanner {
  flex-shrink: 0;
  margin-left: $spacer;
  color: $light-text !important;
  margin-top: -6px !important;
  margin-bottom: -6px !important;
  margin-right: -6px !important;
}

.banner.info {
  background: $primary;
}

.banner.error {
  background: $error;
}

.banner.warning {
  background: $warning;
  color: $dark-text;
  .closeBanner {
    color: $dark-text !important;
  }
}

.banner.deferred {
  background: $deferred;
}

.banner.error-faded {
  background: $error-faded-1;
  color: $text-default;
  .closeBanner {
    color: $text-default !important;;
  }

  .bannerTitle {
    font-weight: $font-weight-medium;
  }
}

.banner.warning-faded {
  background: $warning-faded-1;
  color: $text-default;
  .closeBanner {
    color: $text-default !important;
  }

  .bannerTitle {
    font-weight: $font-weight-medium;
  }
}
